"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var UvSharedApi_1 = __importDefault(require("./UvSharedApi"));
var UvBuildingsApi_1 = __importDefault(require("./UvBuildingsApi"));
var UvPortfoliosApi_1 = __importDefault(require("./UvPortfoliosApi"));
var UvDashboardApi_1 = __importDefault(require("./UvDashboardApi"));
var UvOneOffFeesApi_1 = __importDefault(require("./UvOneOffFeesApi"));
var UvNotificationsApi_1 = __importDefault(require("./UvNotificationsApi"));
var UvProfileApi_1 = __importDefault(require("./UvProfileApi"));
var FacilitiesManagersApi_1 = __importDefault(require("./FacilitiesManagersApi"));
var ContactsApi_1 = __importDefault(require("./ContactsApi"));
var WebsitesApi_1 = __importDefault(require("./WebsitesApi"));
var Api = {
    shared: new UvSharedApi_1.default(),
    buildings: new UvBuildingsApi_1.default(),
    portfolios: new UvPortfoliosApi_1.default(),
    dashboard: new UvDashboardApi_1.default(),
    oneOffFees: new UvOneOffFeesApi_1.default(),
    notifications: new UvNotificationsApi_1.default(),
    profile: new UvProfileApi_1.default(),
    facilitiesManagers: new FacilitiesManagersApi_1.default(),
    contacts: new ContactsApi_1.default(),
    websites: new WebsitesApi_1.default(),
};
exports.default = Api;
//https://codeburst.io/create-http-client-instance-with-axios-in-vue-da8c12c779c2
//https://www.codementor.io/@capocaccia/keeping-axios-where-it-belongs-o6xidrkrk
//https://blog.logrocket.com/how-to-make-http-requests-like-a-pro-with-axios/
//https://stackoverflow.com/questions/49482429/axios-on-nodejs-wont-retain-session-on-requested-server-while-postman-does  
//# sourceMappingURL=UvApiService.js.map